var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import { IconAdjustments, IconSquare, IconSquareCheck, } from '@tabler/icons-react';
import { ActionIcon, Menu, Text } from '@mantine/core';
export default function ColumnVisibility(_a) {
    var _b = _a.columns, columns = _b === void 0 ? [] : _b, _c = _a.hiddenColumns, hiddenColumns = _c === void 0 ? [] : _c, updateHiddenColumns = _a.updateHiddenColumns;
    function onItemClick(accessor) {
        if (updateHiddenColumns) {
            var _newHiddenColumns = __spreadArray([], hiddenColumns, true);
            if (_newHiddenColumns.includes(accessor)) {
                _newHiddenColumns = _newHiddenColumns.filter(function (e) { return e !== accessor; });
            }
            else {
                _newHiddenColumns.push(accessor);
            }
            updateHiddenColumns(_newHiddenColumns);
        }
    }
    return (React.createElement(Menu, { withArrow: true },
        React.createElement(Menu.Target, null,
            React.createElement(ActionIcon, { color: "blue", variant: "light" },
                React.createElement(IconAdjustments, { size: 16 }))),
        React.createElement(Menu.Dropdown, null, columns.map(function (col) { return (React.createElement(Menu.Item, { key: col.accessor, color: (hiddenColumns === null || hiddenColumns === void 0 ? void 0 : hiddenColumns.includes(col.accessor)) ? 'gray' : 'blue', onClick: updateHiddenColumns ? function () { return onItemClick(col.accessor); } : undefined, leftSection: (hiddenColumns === null || hiddenColumns === void 0 ? void 0 : hiddenColumns.includes(col.accessor)) ? (React.createElement(IconSquare, { size: 14 })) : (React.createElement(IconSquareCheck, { size: 14 })) },
            React.createElement(Text, { size: 'xs' }, col.title))); }))));
}
